<template>
  <div class="commit-div">
    <div class="commit-box">
      <div class="commit2">
        <div class="title">
          <span class="left1"></span>
          <span class="left2"></span>
          <span class="left3"></span>
          <span style="font-size:36px" class="middle">投稿避坑指南</span>
          <span class="right1"></span>
          <span class="right2"></span>
          <span class="right3"></span>
        </div>
        <div class="check" v-if="!check2Data" @click="check2()">查看详情</div>
        <div class="check" v-if="check2Data" @click="check2()">收起</div>
      </div>
      <div class="commit1">
        <div class="title">
          <span class="left1"></span>
          <span class="left2"></span>
          <span class="left3"></span>
          <span style="font-size:36px" class="middle">稿件受理流程</span>
          <span class="right1"></span>
          <span class="right2"></span>
          <span class="right3"></span>
        </div>
        <div class="check" v-if="!check1Data" @click="check1()">查看详情</div>
        <div class="check" v-if="check1Data" @click="check1()">收起</div>
      </div>
    </div>
    <div style="margin-top: 50px">
      <el-collapse-transition>
        <div v-show="check1Data">
          <img src="../assets/img/progress.jpg" alt="" />
        </div>
      </el-collapse-transition>
      <el-collapse-transition>
        <div v-show="check2Data">
          <div class="guide">
            <p>
              在游卡原创桌游投稿平台运作的这段时间以来，平台收到了数百份原创桌游的投稿，其中有很大一部分因为游戏设计之外的原因无法通过初审。我们整理了最常见的三个问题，在您投稿之前可以检查一下是否存在有类似的情况以提高通过审核的概率：
            </p>
            <h4>规则书写作不清晰</h4>
            <p>
              在平台上，有50%以上的作品都因为规则书难以被读懂、难以被理解而无法通过初审！规则书是向他人展示桌游玩法最重要的途径，如果因为读不懂规则或理解错规则的含义而影响了游戏体验，必定会导致作品无法通过初审。
            </p>
            <p>
              <a
                style="color: red; font-weight: bold"
                :href="downloadUrl"
                download="writing_template.docx"
                >点击此处</a
              >
              <!-- <span style="color: red; font-weight: bold" @click="download">点击此处</span> -->
              下载一个简单的规则书写作模板。如果您对如何书写一个“简单易懂的规则书”并无把握的话，不妨参考模板的内容来重新调整规则书的内容。您也可以通过视频教学的方式来讲解您的游戏，在投稿文字规则的同时，在作品简介中附上视频教学的链接。
            </p>
            <h4>投稿以市面现有作品进行改编，或为其设计了扩展</h4>
            <p>
              严格来说，平台仅接受原创桌游的投稿。因此如果您的投稿是针对现有作品进行扩充或改编，那么它将无法通过初审。
            </p>
            <h4>投稿缺少能展现游戏核心内容的资料</h4>
            <p>
              虽然投稿平台在初审阶段并不需要您提供完整的游戏资料和设计，但所展现的内容必须要包含游戏的核心部分，否则将无法了解作品的具体质量。
            </p>
            <p>
              比较典型的例子包括：以套牌构筑或卡牌互动为核心的游戏，并没有给出卡牌效果的具体设计；以版图作为重要游戏游戏元素，但缺少版图信息的展示；以剧情为核心体验的游戏，仅给出了剧情梗概，等等。
            </p>
            <p>
              当您的作品避开了以上三个问题之后，就可以尝试在投稿平台进行提交了！平台的审核人员会在三个工作日内告知您初审结果。
            </p>
            <p>期待您的创意！</p>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div style="text-align: left; width: 60%; margin: 0 auto">
      <p class="c-red">
        注意：为保护投稿者知识产权，我方会对所有投稿资料进行严格保密。若投稿通过最终审核，将与作者签订授权协议后进行出版，否则不会对外公布投稿内容。也请各位投稿者注意留存版权证明，避免来自外界的知识产权侵害！
      </p>
      <p>如果您已经做好了投稿准备，请登录后点击下方按钮进行投递初稿</p>
      <el-button
        type="primary"
        class="send"
        round
        size="medium"
        @click="writeMessage"
        >投递初稿</el-button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      Isflow: true,
      form: {
        title: "",
        location: "",
        type: "",
        age: "",
        time_game: "",
        players_down: "",
        players_up: "",
        introduction: "",
        is_agree: "1",
        first_checkfile: "",
      },
      fileList: [],
      uploadHost: process.env.BASE_URL + "/oss/get-sign?type=2",
      ossParams: {
        key: "", // key后面有用，先默认设空字符串
        success_action_status: "200", // 默认200
      },
      picOSS: false,
      dir: "",
      Istitle: false,
      Islocation: false,
      Istype: false,
      Istime: false,
      Isage: false,
      Isplayers: false,
      IstitleNull: false,
      login: false,
      check1Data: false,
      check2Data: false,
      downloadUrl: "",
    };
  },
  methods: {
    init() {
      axios({
        method: "post",
        url: process.env.BASE_URL + "/login/is-login",
        withCredentials: true,
      }).then((res) => {
        if (res.data.code == 10000) {
          this.login = true;
        } else {
          this.login = false;
        }
      });
    },
    writeMessage() {
      if (this.login == true) {
        this.$router.push({ path: "/commitdetail" });
      } else {
        this.$message("请先登录");
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    firstPost() {
      //				axios({
      //					method:'post',
      //					url:process.env.BASE_URL + '/login/is-login',
      //					withCredentials:true,
      //				})
      //				.then(res =>{
      //					if(res.data.code == 10000){
      if (this.form.title.length < 1) {
        this.IstitleNull = true;
        this.Istitle = false;
      }
      if (this.form.title.length > 30) {
        this.Istitle = true;
        this.IstitleNull = false;
      }
      if (this.form.location.length < 1) {
        this.Islocation = true;
      }
      if (this.form.type.length < 1) {
        this.Istype = true;
      }
      if (this.form.age.length < 1) {
        this.Isage = true;
      }
      if (this.form.time_game.length < 1) {
        this.Istime = true;
      }
      if (
        this.form.players_down > this.form.players_up ||
        this.form.players_up < 1 ||
        this.form.players_down < 1
      ) {
        this.Isplayers = true;
      }
      if (this.picOSS == true) {
        var form = new FormData();
        form.append("title", this.form.title);
        form.append("location", this.form.location);
        form.append("type", this.form.type);
        form.append("age", this.form.age);
        form.append("time_game", this.form.time_game);
        form.append("players_down", this.form.players_down);
        form.append("players_up", this.form.players_up);
        form.append("introduction", this.form.introduction);
        form.append("is_agree", this.form.is_agree);
        form.append("first_checkfile", this.dir);
        axios({
          method: "post",
          url: process.env.BASE_URL + "/apply/first-commit",
          data: form,
          withCredentials: true,
        }).then((res) => {
          if (res.data.code == 10000) {
            this.$message({
              message: "投稿成功",
              type: "success",
            });
            //							        this.form = {}
            //							        this.form.is_agree = '1'
            //							        this.fileList = []
          } else {
            this.$message({
              message: res.data.message,
              type: "warning",
            });
          }
        });
      } else {
        this.$message("请选择文档");
      }
      //					} else{
      //						this.$message(res.data.message)
      //					}
      //				})
    },
    handleSuccess(res, file) {
      this.dir = res.dir + file.name;
      var form3 = new FormData();
      form3.append("name", file.name);
      form3.append("key", res.dir + "${filename}");
      form3.append("policy", res.policy);
      form3.append("OSSAccessKeyId", res.accessid);
      form3.append("success_action_status", "200");
      form3.append("signature", res.signature);
      form3.append("file", file.raw);
      axios({
        method: "post",
        url: res.host,
        data: form3,
        withCredentials: false,
      }).then((res) => {
        this.picOSS = true;
      });
    },
    check1() {
      if (this.check1Data == false) {
        var promise = new Promise((resolve, reject) => {
          this.check2Data = false;
          resolve(1);
        });
        promise.then(() => {
          setTimeout(() => {
            this.check1Data = true;
          }, 500);
        });
      } else {
        this.check1Data = false;
      }
    },
    check2() {
      if (this.check2Data == false) {
        var promise = new Promise((resolve, reject) => {
          this.check1Data = false;
          resolve(1);
        });
        promise.then(() => {
          setTimeout(() => {
            this.check2Data = true;
          }, 500);
        });
      } else {
        this.check2Data = false;
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.downloadUrl = location.origin + "/static/writing_template.docx";
  },
};
</script>

<style scoped>
.commit-div {
  text-align: center;
}

.commit-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.commit1 {
  padding-top: 270px;
  display: inline-block;
  width: 35%;
  vertical-align: top;
}
.title {
  width: 400px;
  margin: 20px auto;
  color: #81b4e9;
  padding-bottom: 30px;
  text-align: center;
}
.left1,
.left2,
.left3,
.right1,
.right2,
.right3 {
  border-top: 2px solid #f48a65;
  border-left: 2px solid #f48a65;
}
.send,
.commitFirst {
  width: 322px;
  height: 86px;
  font-size: 33px;
  display: block;
  margin: 80px auto;
}
.commit2 {
  padding-top: 270px;
  width: 35%;
  display: inline-block;
  vertical-align: top;
  /* margin: 0 auto; */
}
.guide {
  height: 600px;
  text-align: left;
  width: 60%;
  margin: 0 auto;
  overflow: hidden;
}
.guide h4 {
  font-size: 18px;
  margin-top: 30px;
  color: #81b4e9;
}
.guide p {
  text-indent: 2em;
}
.formCommit {
  padding-left: 150px;
}
.title3 {
  color: black;
}
.left1,
.left2,
.left3,
.right1,
.right2,
.right3 {
  border-top: 2px solid gray;
  border-left: 2px solid gray;
}
.inputName {
  width: 412px;
}
.inputName1 {
  width: 150px;
  padding-right: 20px;
}
.rules img {
  padding-left: 20px;
  padding-right: 20px;
}
.rules {
  color: #f48a65;
}
.tiaoyue {
  width: 791px;
  height: 308px;
  border: 1px solid gray;
  border-radius: 15px;
  margin-bottom: 27px;
  outline: none;
  margin-left: 95px;
}
.introduction .introductionSpan {
  font-size: 28px;
  color: black;
}
.agreement {
  text-align: center;
  margin: 0px auto;
  width: 1000px;
}
.upload-demo {
  width: 730px;
}
.c-red {
  color: #ff6a30;
  line-height: 24px;
  padding-top: 40px;
}
.check {
  border: none;
  width: 150px;
  height: 40px;
  background-color: rgb(43, 226, 43);
  border-radius: 15px;
  color: white;
  font-weight: bold;
  margin: 0 auto;
  display: block;
  line-height: 40px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/commit.vue